import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-text',
  templateUrl: './smart-text.component.html',
  styleUrls: ['./smart-text.component.css']
})
export class SmartTextComponent implements OnInit {

  
  @Input() text;
  @Input() limit;

  buffer = null;

  constructor() { }

  ngOnInit(): void {
    if(this.text){
      this.buffer = this.text;
    } 
  }

  getDisplayText(){
    if(this.buffer){
      let dots = '';
      this.buffer.length > this.limit? dots = '...' : null;
      return this.buffer.slice(0,this.limit)+dots;
    }else{
      return '';
    }
  }

}
